import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./styles.css";
import { AppConfigProvider } from "./AppConfigContext.js";
import { AuthProvider } from "./AuthContext.js";
import Layout from "./components/Layout.js";
import Library from "./pages/Library.js";
import NewUpload from "./pages/NewUpload.js";
import YoutubeImport from "./pages/YoutubeImport.js";
import VideoDetail from "./pages/VideoDetail.js";
import Jobs from "./pages/Jobs.js";
import Creators from "./pages/Creators.js";
import CreatorDetail from "./pages/CreatorDetail.js";
import MyProfile from "./pages/MyProfile.js";
import Login from "./pages/Login.js";
import Apply from "./pages/Apply.js";
import Applications from "./pages/Applications.js";
import ApplicationDetail from "./pages/ApplicationDetail.js";

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <AuthProvider>
      <AppConfigProvider>
        <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Library />} />
              <Route path="/new" element={<NewUpload />} />
              <Route path="/import" element={<YoutubeImport />} />
              <Route path="/videos/:id" element={<VideoDetail />} />
              <Route path="/jobs" element={<Jobs />} />
              <Route path="/creators" element={<Creators />} />
              <Route path="/creators/:id" element={<CreatorDetail />} />
              <Route path="/profile" element={<MyProfile />} />
              <Route path="/login" element={<Login />} />
              <Route path="/apply" element={<Apply />} />
              <Route path="/applications" element={<Applications />} />
              <Route path="/applications/:id" element={<ApplicationDetail />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </AppConfigProvider>
    </AuthProvider>
  </React.StrictMode>,
);
